import { SLOTS } from './slots.js'

// Media uploads — read-only triage list of prepared uploads that failed or expired.
// An upload has no page of its own, so rows carry no `edit_url` (no edit action). The
// evidence badge is colored by `evidence.status`; its per-row label and hover detail
// are computed server-side (AdminSite::MediaUploadRows).
const STATE_BADGES = {
  prepared: { label: 'Prepared', badgeClass: 'badge-warning' },
  consumed: { label: 'Consumed', badgeClass: 'badge-success' },
  expired: { label: 'Expired', badgeClass: 'badge-ghost' },
  failed: { label: 'Failed', badgeClass: 'badge-error' }
}

const EVIDENCE_BADGES = {
  unknown: { label: 'Unknown', badgeClass: 'badge-ghost' },
  nothing: { label: 'Nothing arrived', badgeClass: 'badge-error' },
  partial: { label: 'Partial', badgeClass: 'badge-warning' },
  complete: { label: 'All files arrived', badgeClass: 'badge-success' }
}

export default {
  key: 'media_upload',
  label: 'Media Upload',
  icon: 'media_uploads',
  columns: [
    { slot: SLOTS.PRIMARY, field: 'user.icon_image_url', label: 'User', renderer: 'avatar', labelField: 'user.name', link: 'user.url' },
    { slot: SLOTS.CONTEXT, field: 'subject.label', label: 'Quest', link: 'subject.url' },
    { slot: SLOTS.STATUS, field: 'state', label: 'State', renderer: 'state_badge', badges: STATE_BADGES },
    { slot: SLOTS.METADATA, field: 'failure_reason', label: 'Reason', renderer: 'state_badge', labelField: 'failure_reason_label', tooltipField: 'failure_message' },
    { slot: SLOTS.METADATA, field: 'evidence.status', label: 'Evidence', renderer: 'state_badge', badges: EVIDENCE_BADGES, labelField: 'evidence.label', tooltipField: 'evidence.detail' },
    { slot: SLOTS.TEMPORAL, field: 'occurred_label', label: 'Failed At', nowrap: true }
  ],
  empty: { icon: 'media_uploads', message: 'No media uploads found.' },
  defaultView: 'table',
  compact: { show: [SLOTS.CONTEXT, SLOTS.METADATA, SLOTS.TEMPORAL] }
}
